const pageNames = {
    horse: 'horse',
    trainer: 'trainer',
    owner: 'owner',
    jockey: 'jockey',
    course: 'course',
};

export const getPageName = (pageName) => {
    switch (pageName) {
        case pageNames.horse:
            return `${pageNames.horse}_profile`;
        case pageNames.trainer:
            return `${pageNames.trainer}_profile`;
        case pageNames.owner:
            return `${pageNames.owner}_profile`;
        case pageNames.jockey:
            return `${pageNames.jockey}_profile`;
        case pageNames.course:
            return `${pageNames.course}_profile`;
        default:
            return '';
    }
};



// WEBPACK FOOTER //
// ./src/js/utils/getPageName.js